// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1MvPV","actions":"GroupTable_actions__33VvS","deleteModalFooter":"GroupTable_deleteModalFooter__1kr9T"};